import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
export interface SpeechRequest {
  text: string; referenceId: string; consent: boolean;
  generationOptions: Record<string, number>; seed: number | null;
}
export interface Generation {
  generationId: string; state: string; stage: string; error?: string; createdAtEpoch: number;
  startedAtEpoch?: number; finishedAtEpoch?: number; request: SpeechRequest; seed: number;
  model: string; revision: string; generationTimeMs?: number; durationMs?: number;
  realTimeFactor?: number; sampleRate: number; audioAvailable: boolean;
  completedChunks?: number; totalChunks?: number; quality?: {rmsDb:number; activeFraction:number; nearSilent:boolean};
}
export interface Reference { referenceId: string; createdAtEpoch: number; durationSeconds: number; label?: string; default?: boolean; }
@Injectable({providedIn: 'root'})
export class IndicParlerApi {
  private readonly base = environment.apiHost + '/api/v1/rnd/xtts-urdu';
  private readonly options = {headers:new HttpHeaders({'X-Skip-Spinner':'true'})};
  constructor(private http: HttpClient) {}
  status() { return this.http.get<any>(this.base + '/status', this.options); }
  config() { return this.http.get<any>(this.base + '/config', this.options); }
  capabilities() { return this.config(); }
  history() { return this.http.get<Generation[]>(this.base + '/history', this.options); }
  references() { return this.http.get<Reference[]>(this.base + '/references', this.options); }
  upload(file:File) { return this.http.post<Reference>(this.base + '/references', file,
    {headers:this.options.headers.set('Content-Type','application/octet-stream').set('X-Voice-Consent','true')}); }
  generate(body: SpeechRequest) { return this.http.post<Generation>(this.base + '/generate', body, this.options); }
  job(id:string) { return this.http.get<Generation>(this.base + '/jobs/' + encodeURIComponent(id), this.options); }
  audio(id: string) { return this.http.get(this.base + '/audio/' + encodeURIComponent(id), {...this.options,responseType:'blob'}); }
  referenceAudio(id:string) { return this.http.get(this.base + '/references/' + encodeURIComponent(id) + '/audio', {...this.options,responseType:'blob'}); }
  delete(id: string) { return this.http.delete(this.base + '/history/' + encodeURIComponent(id), this.options); }
  deleteReference(id:string) { return this.http.delete(this.base + '/references/' + encodeURIComponent(id), this.options); }
}
